import router from '@/router'
import BasicLayout from '@/layouts/BasicLayout.vue'
import { setGlobalMenus } from '@/core/global-data'
import { asyncRoute } from '@/router/router.config'
import { getLsPermission, getLsUserInfo } from './storage/ls'

function hasPermission(permission_list, route) {
  // 超管专属路由：仅 root === 1 的超管可注册/访问
  if (route.meta && route.meta.root) {
    const userInfo = getLsUserInfo() || {}
    return Number(userInfo.root) === 1
  }
  if (route.meta && route.meta.permission) {
    let flag = false
    for (let i = 0, len = permission_list.length; i < len; i++) {
      flag = route.meta.permission === permission_list[i]
      if (flag) {
        return true
      }
    }
    return false
  }
  return false
}

function filterAsyncRouter(routerMap, permission_list) {
  const accessedRouters = routerMap.filter((route) => {
    if (hasPermission(permission_list, route)) {
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children, permission_list)
      }
      return true
    }
    return false
  })
  return accessedRouters
}

function findFirstRouter(routes) {
  for (let i = 0; i < routes.length; i++) {
    const route = routes[i]
    if (!route.children || !route.children.length) {
      if (!route.hidden) {
        return route.path
      }
    } else {
      return findFirstRouter(route.children)
    }
  }
}

export default function generatePermission() {
  
  const modules = getLsPermission()
  // 不做权限控制
  const routes = filterAsyncRouter(asyncRoute, modules)
  // const routes = asyncRoute
  // console.log('routes', routes);
  setGlobalMenus(routes)
  
  const firstPath = findFirstRouter(routes)
  router.addRoute({
    path: '/',
    name: 'index',
    component: BasicLayout,
    meta: { title: '首页' },
    redirect: firstPath,
    children: routes,
  })

  // const modules = getLsPermission()
  // // // 不做权限控制
  // const routes = filterAsyncRouter(asyncRoute, modules)
  // // const routes = asyncRoute
  // console.log('routes', routes, modules);

  // setGlobalMenus(asyncRoute) 
  // const firstPath = findFirstRouter(asyncRoute)
  // router.addRoute({
  //   path: '/',
  //   name: 'index',
  //   component: BasicLayout,
  //   meta: { title: '首页' },
  //   redirect: firstPath,
  //   children: asyncRoute,
  // })
}